import type { IconData } from '@stacksjs/iconify-core'

export const tl4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGo1QMTd8m\"><path fill-opacity=\".7\" d=\"M0 0h682.7v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGo1QMTd8m)\" transform=\"scale(.9375)\"><path fill=\"#cb000f\" d=\"M0 0h1031.2v512H0z\"/><path fill=\"#f8c00c\" d=\"M0 0c3.2 0 512 256.7 512 256.7L0 512z\"/><path fill=\"#000001\" d=\"M0 0c2.1 0 340.6 256.7 340.6 256.7L0 512z\"/><path fill=\"#fff\" d=\"M187.7 298.2L127 284.7l-31 52.8l-5-59.7l-60.7-13.3l54.9-24.9l-3.3-59.3l40.2 43.4l55.4-25.3l-28.9 54l39.2 45.8z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default tl4x3
